import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NcAppNavigationCaption = _resolveComponent("NcAppNavigationCaption")
  const _component_ParticipantsList = _resolveComponent("ParticipantsList")
  const _component_IconAccountPlusOutline = _resolveComponent("IconAccountPlusOutline")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_NavigationHint = _resolveComponent("NavigationHint")
  const _component_IconAccountSearchOutline = _resolveComponent("IconAccountSearchOutline")
  const _component_NcEmptyContent = _resolveComponent("NcEmptyContent")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["participants-search-results", { scrollable: $props.scrollable }])
  }, [
    ($options.addableUsers.length !== 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!$props.onlyUsers)
            ? (_openBlock(), _createBlock(_component_NcAppNavigationCaption, {
                key: 0,
                name: $options.t('spreed', 'Add users')
              }, null, 8, ["name"]))
            : _createCommentVNode("", true),
          _createVNode(_component_ParticipantsList, {
            items: $options.addableUsers,
            "is-search-result": "",
            onClick: $options.handleClickParticipant
          }, null, 8, ["items", "onClick"])
        ], 64))
      : _createCommentVNode("", true),
    (!$props.onlyUsers)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          ($options.addableGroups.length !== 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_NcAppNavigationCaption, {
                  name: $options.t('spreed', 'Add groups')
                }, null, 8, ["name"]),
                _createVNode(_component_ParticipantsList, {
                  items: $options.addableGroups,
                  "is-search-result": "",
                  onClick: $options.handleClickParticipant
                }, null, 8, ["items", "onClick"])
              ], 64))
            : _createCommentVNode("", true),
          ($options.addableEmails.length !== 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_NcAppNavigationCaption, {
                  name: $options.t('spreed', 'Add emails')
                }, null, 8, ["name"]),
                _createVNode(_component_ParticipantsList, {
                  items: $options.addableEmails,
                  "is-search-result": "",
                  onClick: $options.handleClickParticipant
                }, null, 8, ["items", "onClick"])
              ], 64))
            : _createCommentVNode("", true),
          ($options.addableCircles.length !== 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createVNode(_component_NcAppNavigationCaption, {
                  name: $options.t('spreed', 'Add teams')
                }, null, 8, ["name"]),
                _createVNode(_component_ParticipantsList, {
                  items: $options.addableCircles,
                  "is-search-result": "",
                  onClick: $options.handleClickParticipant
                }, null, 8, ["items", "onClick"])
              ], 64))
            : _createCommentVNode("", true),
          ($options.integrations.length !== 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createVNode(_component_NcAppNavigationCaption, {
                  name: $options.t('spreed', 'Integrations')
                }, null, 8, ["name"]),
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.integrations, (integration, index) => {
                    return (_openBlock(), _createBlock(_component_NcButton, {
                      key: 'integration' + index,
                      variant: "tertiary-no-background",
                      onClick: $event => ($options.runIntegration(integration))
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_IconAccountPlusOutline, { size: 20 })
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" " + _toDisplayString(integration.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ])
              ], 64))
            : _createCommentVNode("", true),
          ($options.addableRemotes.length !== 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _createVNode(_component_NcAppNavigationCaption, {
                  name: $options.t('spreed', 'Add federated users')
                }, null, 8, ["name"]),
                _createVNode(_component_ParticipantsList, {
                  items: $options.addableRemotes,
                  "is-search-result": "",
                  onClick: $options.handleClickParticipant
                }, null, 8, ["items", "onClick"])
              ], 64))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    ($options.sourcesWithoutResults && !$props.onlyUsers)
      ? (_openBlock(), _createBlock(_component_NcAppNavigationCaption, {
          key: 2,
          name: $options.sourcesWithoutResultsList
        }, null, 8, ["name"]))
      : _createCommentVNode("", true),
    ($props.contactsLoading)
      ? (_openBlock(), _createBlock(_component_NavigationHint, {
          key: 3,
          hint: $options.t('spreed', 'Searching …')
        }, null, 8, ["hint"]))
      : ($options.sourcesWithoutResults)
        ? (_openBlock(), _createBlock(_component_NavigationHint, {
            key: 4,
            hint: $options.t('spreed', 'No search results')
          }, null, 8, ["hint"]))
        : _createCommentVNode("", true),
    ($props.showSearchHints)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
          ($props.noResults)
            ? (_openBlock(), _createBlock(_component_NcEmptyContent, {
                key: 0,
                name: $options.t('spreed', 'No results')
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_IconAccountSearchOutline)
                ]),
                _: 1
              }, 8, ["name"]))
            : ($options.displaySearchHint)
              ? (_openBlock(), _createBlock(_component_NcButton, {
                  key: 1,
                  class: "participants-search-results__hint",
                  variant: "tertiary",
                  onClick: $options.handleClickHint
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_IconAccountSearchOutline, { size: 20 })
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Search for more users')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ], 2))
}